import "./index.css";

import { NotFound } from "@repo/ui";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { EvaluateurGuard } from "./components/evaluateur-guard";
import { EvaluateurView } from "./routes/evaluateur-view";
import { ReferentielView } from "./routes/referentiel-view";

const router = createBrowserRouter([
  // Route évaluateur - authentification légère (nom/token + parcoursEvaluateurId)
  {
    path: "/pe/:id",
    element: <EvaluateurGuard />,
    children: [
      {
        index: true,
        element: <EvaluateurView />,
      },
      // Contribution au référentiel d'une campagne : passation interne à ce
      // portail (contrairement aux notations de candidats, ouvertes dans l'app
      // de notation).
      {
        path: "referentiel/:notationId",
        element: <ReferentielView />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
